<template>
  <section class="vbox">
    <section class="scrollable wrapper">
      <section class="hbox stretch">
        <div class="content-header">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item><a href="/">系统</a></el-breadcrumb-item>
            <el-breadcrumb-item>行业列表</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="content-main">
          <el-form :inline="true" size="medium">            
            <el-form-item>
              <el-button type="primary" class="el-icon-circle-plus-outline" v-on:click="AddIndustry" size="small" >新增</el-button>
            </el-form-item>
            <el-form-item >
              <el-input  placeholder="行业名称" v-model="name" size="small" clearable></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" v-on:click="Search" size="small" >查询</el-button>
            </el-form-item>
          </el-form>
          <el-table :data="industrys" style="width: 100%" >
            <el-table-column  prop="Name"  label="名称"> </el-table-column>
            <el-table-column  prop="Icon"  label="图标" >        
              <template slot-scope="scope">
        　　　　<img :src="scope.row.Icon" width="20" height="20"/>
              </template>
            </el-table-column>
            <el-table-column  prop="Sort" label="排序"> </el-table-column>
            <el-table-column  prop="OnlineView"  label="商城显示" > 
              <template slot-scope="scope">                    
                <p v-if="scope.row.OnlineView==true">显示</p>
                <p v-if="scope.row.OnlineView==false">不显示</p>         
              </template>
            </el-table-column>
            <el-table-column  prop="Memo"  label="备注" > </el-table-column>
            <el-table-column  fixed="right" label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click.native.prevent="editIndustry(scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click="deleteRow(scope.row)" type="text" size="small"> 删除</el-button>              
            </template>
          </el-table-column>
          </el-table>
          <el-pagination
            :hide-on-single-page="true"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageIndex"
            :page-sizes="[10, 20, 30, 50]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalCount">
          </el-pagination>
        </div>
      </section>
    </section>
    <dia v-bind:dialog="dialog" @GetData="GetData"></dia>
  </section>
</template>
<script  type='text/ecmascript-6'>
  import dia from './info'
  export default {
    props:{
    },
    data (){
      return {
        name:'',
        pageIndex:1,
        pagesize:10,
        totalCount:10,
        sort:'sort asc',
        industrys:[],
        dialog: {
          id:'0',
          title: '',
          isShow:false
        },
      }
    },
    computed:{
    },
    mounted(){
      this.GetData();
    },
    methods:{     
      Search:function(){
        this.pageIndex = 1;
        this.GetData();
      },
      AddIndustry:function(){
        this.dialog.id = ''
        this.dialog.title = '新增行业'
        this.dialog.isShow = true
      },
      GetData:function(){
        var that = this
        this.axios({
          method:'get',
          url:that.global.serverSrc + '/api/Industry/Index',
          params:{
            name : that.name,
            pageIndex : that.pageIndex,
            pagesize : that.pagesize,
            sort : that.sort
          }
        }).then(function (resp) {
          that.totalCount = resp.data.totalCount
          that.industrys = resp.data.industrys
        }).catch(resp => {
          console.log('请求失败：' + resp.message + ',' + resp.stack)
        })
      },
      deleteRow(id) {        
        this.$confirm('确定要删除该行业吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var that = this
          this.axios({
            method:'post',
            url:that.global.serverSrc + '/api/Industry/Delete',
            data:{
              id: id
            }
          }).then(function (resp) {  
            if(resp.data.errorCode==0){              
              that.$message.success(resp.data.message);
              that.GetUserRoleData();
            }else {              
              that.$message.warning(resp.data.message);
            }
          }).catch(resp => {
            console.log('请求失败：' + resp.message + ',' + resp.stack)
          })
        }).catch(() => {
            
        });
      },
      editIndustry:function(row){
        this.dialog.id = row.Id
        this.dialog.title = '修改行业'
        this.dialog.isShow = true 
      },
      handleSizeChange(val) {
        this.pagesize = val
        this.pageIndex = 1
        this.GetData()
      },
      handleCurrentChange(val) {
        this.pageIndex = val
        this.GetData()
      }
    },
    components:{     
      dia
    },
    created(){
    
    },
  }
</script>
<style lang='stylus' rel='stylesheet/stylus'>
.content-header
  padding 24px
  border 1px solid #C0C4CC
.content-main
  padding 24px  
</style>